import type { Step } from "react-joyride";

export const collectionFormTourSteps: Step[] = [
  {
    target: "body",
    content:
      "ຟອມສ້າງ/ແກ້ໄຂ Collection. ຕື່ມຊື່ 3 ພາສາ (ລາວ, ไทย, EN), Slug (ສ້າງອັດຕະໂນມັດ), ແລະ ລຳດັບການສະແດງ.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tourid="collection-form-nameLo"]',
    content: "ຊື່ພາສາລາວ — ບັງຄັບ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="collection-form-nameEn"]',
    content: "ຊື່ພາສາອັງກິດ — ໃຊ້ສຳລັບສ້າງ Slug ອັດຕະໂນມັດ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="collection-form-slug"]',
    content:
      "Slug (URL identifier) — ສ້າງອັດຕະໂນມັດຈາກຊື່ອັງກິດ, ບໍ່ສາມາດແກ້ໄຂໄດ້.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="collection-form-sortOrder"]',
    content: "ລຳດັບການສະແດງ — ຕົວເລກທີ່ກຳນົດລຳດັບການສະແດງໃນລາຍການ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="collection-form-submit"]',
    content: "ກົດ 'ບັນທຶກ' ເພື່ອບັນທຶກ ຫຼື 'ຍົກເລີກ' ເພື່ອກັບຄືນ.",
    placement: "top",
  },
];
